import { render, staticRenderFns } from "./Section-05.vue?vue&type=template&id=88bab4ac&scoped=true&"
import script from "./Section-05.vue?vue&type=script&lang=js&"
export * from "./Section-05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bab4ac",
  null
  
)

export default component.exports